@import '../../../../../../../../constants/spacing.module.less';

.inventory-management-header {
  font-weight: 700;
  text-align: left;
  margin-top: @space-40;
}

.inventory-management-description {
  text-align: left;
  margin-bottom: @space-40;
}
